module.exports = __webpack_public_path__ + "static/media/emoji-average.77415171.svg";